import { Injectable } from '@angular/core';
import { ListHelperService, ProfileService, StoreService, CountriesService, LocalesService } from 'core/services';
import { TechTestService } from './tech-test.service';
import { TranslateService } from '@ngx-translate/core';
import { DataTypes, TableDatasource } from '@gamelearn/skeletor/models';
import { DateTime } from 'luxon';

@Injectable()
export class TechTestListService {
  userRole: any;

  constructor(
    public techTestService: TechTestService,
    public translate: TranslateService,
    public profileService: ProfileService,
    public listHelper: ListHelperService,
    public countriesService: CountriesService,
    public locales: LocalesService
  ) {
    profileService.getLoggedUserRole$().subscribe((userRole) => (this.userRole = userRole));
  }

  async getDatasource(listId, options: any = {}) {
    const dataSource = new TableDatasource({
      sort: 'email',
      columns: this.getColumns(),
      load: (props) => this.fetch(props, dataSource),
      storeState: {
        enabled: true,
        key: `${listId}_${this.userRole.name}`
      },
      ...options
    });
    await dataSource.refreshData();
    StoreService.create(listId, dataSource);
    return dataSource;
  }

  fetch({ page, limit, sort, search, filters, aggregates, populate }, dataSource: TableDatasource) {
    const { clientId, ...$filterValues } = filters;
    const $filter = this.listHelper.buildFilterString($filterValues, dataSource, this.getCustomFilters());

    const paginationOptions = {
      page,
      limit,
      sort,
      search,
      aggregates,
      populate,
      clientId,
      $filter
    };
    return this.techTestService.fetch(paginationOptions).then((response) => response);
  }

  getColumns() {
    const columns = [
      {
        source: 'email',
        label: this.translate.instant('techTests.header.email'),
        sortable: true
      },
      {
        source: 'notification.received_at',
        label: this.translate.instant('techTests.header.started'),
        sortable: true,
        dataType: DataTypes.datetime,
        valueParser: (value) => {
          const format = DateTime.DATETIME_MED_WITH_SECONDS;
          return this.listHelper.parseDate(value, 'utc', format);
        }
      },
      {
        source: 'audio',
        label: this.translate.instant('techTests.header.audio'),
        sortable: false,
        cellRenderer: (renderer, value) =>
          value
            ? renderer`<gl-icon style="color: var(--aqua-marine);font-size:24px;font-weight: bold" icon="glicon-check"></gl-icon>`
            : renderer`<gl-icon style="color: var(--coral);font-size:24px;font-weight: bold" icon="glicon-close"></gl-icon>`
      },
      {
        source: 'domains',
        label: this.translate.instant('techTests.header.domains'),
        sortable: false,
        cellRenderer: (renderer, value) =>
          value
            ? renderer`<gl-icon style="color: var(--aqua-marine);font-size:24px;font-weight: bold" icon="glicon-check"></gl-icon>`
            : renderer`<gl-icon style="color: var(--coral);font-size:24px;font-weight: bold" icon="glicon-close"></gl-icon>`
      },
      {
        source: 'graphics',
        label: this.translate.instant('techTests.header.graphics'),
        sortable: false,
        cellRenderer: (renderer, value) =>
          value
            ? renderer`<gl-icon style="color: var(--aqua-marine);font-size:24px;font-weight: bold" icon="glicon-check"></gl-icon>`
            : renderer`<gl-icon style="color: var(--coral);font-size:24px;font-weight: bold" icon="glicon-close"></gl-icon>`
      }
    ];
    return columns;
  }

  getCustomFilters() {
    return {};
  }
}
